import { render, staticRenderFns } from "./tenantConfig.vue?vue&type=template&id=0b59b830&scoped=true&"
import script from "./tenantConfig.vue?vue&type=script&lang=js&"
export * from "./tenantConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b59b830",
  null
  
)

export default component.exports